export default "__VITE_ASSET__uoHXCWVd__"